import React from 'react'
import AddReasonForm from '../../../component/form/master/reason/AddReasonForm'

export default function AddReason() {
    return (
        <>
            <div className='container-fluid'>
                <div className="row">
                    <div className="col-md-12">
                        <AddReasonForm />
                    </div>
                </div>
            </div>
        </>
    )
}


